<h4>{{ 'recipe.informationHeadline' | translateSafe }}</h4>
<div role="grid" class="info-wrapper">
    <div role="row" class="info" *ngIf="data.cookingTimeDays || data.cookingTimeHours || data.cookingTimeMinutes">
        <div role="gridcell" class="label display-6" id="label-time">
            {{ 'recipe.information.cookingTime' | translateSafe }}
        </div>
        <div role="gridcell" class="value" id="value-time" aria-labelledby="label-time">
            <span *ngIf="data.cookingTimeDays"
                >{{ data.cookingTimeDays }}
                {{ (data.cookingTimeDays === 1 ? 'time.day' : 'time.days') | translateSafe }}
            </span>
            <span *ngIf="data.cookingTimeHours"
                >{{ data.cookingTimeHours }}
                {{ (data.cookingTimeHours === 1 ? 'time.hour' : 'time.hours') | translateSafe }}
            </span>
            <span *ngIf="data.cookingTimeMinutes"
                >{{ data.cookingTimeMinutes }}
                {{ (data.cookingTimeMinutes === 1 ? 'time.minute' : 'time.minutes') | translateSafe }}
            </span>
        </div>
    </div>
    <ng-container *ngFor="let info of headerInformation | keyvalue">
        <div role="row" class="info" *ngIf="info.key && info.value">
            <div role="gridcell" class="label display-6" id="label-{{ info.key }}">
                {{ 'recipe.information.' + info.key | translate }}
            </div>
            <div role="gridcell" class="value" id="value-{{ info.key }}" [attr.aria-labelledby]="'label-' + info.key">
                {{ info.value }}
            </div>
        </div>
    </ng-container>
    <div role="row" class="info" *ngIf="data.suitableForDiet?.length">
        <div role="gridcell" class="label display-6" id="label-suitableForDiet">
            {{ 'recipe.information.suitableForDiet' | translateSafe }}
        </div>
        <div role="gridcell" class="value" id="value-suitableForDiet" aria-labelledby="label-suitableForDiet">
            {{ data.suitableForDiet?.join(', ') }}
        </div>
    </div>
    <div role="row" class="info" *ngIf="data.allergies?.length">
        <div role="gridcell" class="label display-6" id="label-allergies">
            {{ 'recipe.information.allergies' | translateSafe }}
        </div>
        <div role="gridcell" class="value" id="value-allergies" aria-labelledby="label-allergies">
            {{ data.allergies?.join(', ') }}
        </div>
    </div>
    <div role="row" class="info" *ngIf="data.calories && data.recipeYield">
        <div role="gridcell" class="label display-6" id="label-calories">
            {{ 'recipe.information.calories' | translateSafe }}
        </div>
        <div role="gridcell" class="value" id="value-calories" aria-labelledby="label-calories">
            {{ data.calories }} ({{ data.calories * data.recipeYield }}
            {{ 'recipe.information.caloriesTotal' | translateSafe }})
        </div>
    </div>
    <ng-container *ngFor="let customInfo of data.additionalInformation">
        <div role="row" class="info" *ngIf="customInfo.recipeInformationHeading && customInfo.content">
            <div role="gridcell" class="label display-6" id="label-{{ customInfo.recipeInformationHeading }}">
                {{ customInfo.recipeInformationHeading }}
            </div>
            <div
                role="gridcell"
                class="value"
                id="value-{{ customInfo.recipeInformationHeading }}"
                [attr.aria-labelledby]="'label-' + customInfo.recipeInformationHeading"
            >
                {{ customInfo.content }}
            </div>
        </div>
    </ng-container>
</div>
